export default "__VITE_ASSET__DBfLEHNt__"